import {base} from '../../../models/base';

export default {
  namespace: 'school_blog',
  state:{},
  reducers: Object.assign(
    base,
    {
      setData(state, {data}){
        console.info("blog/data: ", data);
        return { ...state, data: data };
      },
    }),
};



// WEBPACK FOOTER //
// ./src/pages/school_blog/models/school_blog.js